import { createFileRoute } from '@tanstack/react-router'
import { AlertsManagement } from '@/features/alerts'

type AlertsSearch = {
  tab?: 'rules' | 'events' | 'channels'
  /** Opens the create-rule dialog prefilled with this metric (deep link from Findings). */
  newRuleMetric?: string
}

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/alerts'
)({
  validateSearch: (search: Record<string, unknown>): AlertsSearch => {
    const tab = search.tab
    const newRuleMetric = search.newRuleMetric
    return {
      tab:
        tab === 'rules' || tab === 'events' || tab === 'channels'
          ? tab
          : undefined,
      newRuleMetric:
        typeof newRuleMetric === 'string' && newRuleMetric.trim().length > 0
          ? newRuleMetric.trim()
          : undefined,
    }
  },
  component: AlertsManagement,
})
